import type { ReactNode } from "react";

import { Ellipsified, Flex, Icon } from "metabase/ui";
import type { ColorName } from "metabase/ui/colors/types";

import type { ComparisonResult } from "../compute";

import S from "./PreviousValueComparison.module.css";

interface Props {
  children: ReactNode;
  color?: ColorName;
  comparison: ComparisonResult;
  iconSize: string | number;
  useComparisonColor?: boolean;
}

export const VariationPercent = ({
  children,
  color,
  comparison,
  iconSize,
  useComparisonColor = true,
}: Props) => {
  const { changeArrowIconName, changeColor } = comparison;
  const semanticColor = useComparisonColor ? changeColor : undefined;
  // Prefer the semantic arrow color (CSS string from getArrowColor). Fall back
  // to the muted token for no-change / missing. Never leave `color` unset —
  // Text defaultProps use text-primary for `--text-color`, and Text.css paints
  // that over `c="inherit"`.
  const percentColor = semanticColor ?? color ?? "inherit";

  return (
    <Flex
      align="center"
      c={semanticColor ? undefined : color}
      maw="100%"
      style={semanticColor ? { color: semanticColor } : undefined}
    >
      {changeArrowIconName && (
        <Icon
          name={changeArrowIconName}
          size={iconSize}
          mr="sm"
          className={S.variationIcon}
        />
      )}

      <Ellipsified
        c={percentColor}
        color={percentColor}
        fw={900}
        showTooltip={false}
      >
        {children}
      </Ellipsified>
    </Flex>
  );
};
